import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'audioNone',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-audio-none wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M12 5.263v13.473c0 .276-.166.346-.368.161l-4.244-3.896H3.491A.496.496 0 0 1 3 14.51V9.488c0-.272.228-.492.491-.492h3.898l4.243-3.894c.203-.186.368-.11.368.161Z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-audio-none.svg',
    category: 'Learning',
    tags: ['volume', 'sound'],
};
export default icon;
